import React, { useEffect, useState } from 'react';

import { useNavigate } from '@reach/router';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

import genericModelTypes from '../../../provider/models/genericModelTypes';
import { sendPost } from '../../../provider/models/reservationModel';
import { formatDate } from '../../../provider/utility';
import {
  changedContactForm,
  changedKnownClient,
  selectedOccurrence,
  selectedRobot,
  sentForm,
} from '../../../store/actions';
import { serviceTypes } from '../../../store/initData/services';
import { env } from '../../../utils/env';
import AccordionFormField from '../../AccordionFormField';
import AccordionOption from '../../AccordionOption/AccordionOption';
import AccordionOptionPayment from '../../AccordionOptionPayment/AccordionOptionPayment';
import Button from '../../Button/Button';
import DatePickerFormField from '../../DatePickerFormField/DatePickerFormField';
import FormField from '../../FormField/FormField';
import { validate } from '../../FormField/helpers';
import FormLabel from '../../FormLabel/FormLabel';
import GeneralTile from '../../GeneralTile/GeneralTile';
import { LocationInfo } from '../../LocationInfo/LocationInfo';
import SelectOption from '../../SelectOption/SelectOption';
import {
  convertWorkshopLevelsToRobotAccordionWithSpecialPrice
} from '../AgePage/helpers';
import FormPageAgreement from '../FormPage/FormPageAgreement/FormPageAgreement';
import WeekDayPicker from '../FormPage/WeekDayPicker';
import { validateWeekDays } from '../FormPage/WeekDayPicker/helpers';
import { summerplayToWeekDays } from '../FormPage/helpers';
import {
  convWorkshopToOption,
  sortByCyclicDate,
  sortByStartDate,
} from '../MapPage/helpers';
import SingleInputPage from '../SingleInputPage/SingleInputPage';
import styles from '../SingleInputPage/SingleInputPage.module.scss';
import './FormPageSingle.scss';

function FormPageSingle({ addressInput }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const currentPage = useSelector((store) => store.state.page);
  const currentService = useSelector((store) => store.state.service);
  const isWorkshopService = currentService.value === serviceTypes.workshop;
  const currentFranchise = useSelector((store) => store.state.city?.franchise);
  const currentRobot = useSelector((store) => store.state.robot);
  const currentLocationId = useSelector((store) => store.state.locationId);
  const mapPageTexts = useSelector((store) => store.data.mapPage);

  const availableWorkshops = useSelector((store) => store.data.workshops);
  const availableWorkshopsCurrentLocation = useSelector(
    (store) => store.data.workshopsCurrentLocation,
  );
  // const availableWorkshopsCurrentLocationAndLevel = [];

  const currentAge = useSelector((store) => store.state.age);
  const currentOccurrence = useSelector((store) => store.state.occurrence);
  const currentForm = useSelector((store) => store.state.contactForm);
  const agreements = useSelector((store) => store.state.agreements);

  const formPageTexts = useSelector((store) => store.data.formPage);
  const formPageSingleTexts = useSelector((store) => store.data.formPageSingle);
  const allPaymentOptions = useSelector((store) => store.data.paymentOptions);
  const sendText = useSelector((store) => store.data.sendText);

  const newIcons = useSelector((store) => store.data.newIcons);

  const availablePaymentOptions =
    currentOccurrence?.payment_type === 'kindergarden_vat_invoice'
      ? allPaymentOptions.filter(
          (po) => po.value === 'kindergarden_vat_invoice',
        )
      : allPaymentOptions.filter(
          (po) => po.value !== 'kindergarden_vat_invoice',
        );

  const isParentPaymentForm =
    currentOccurrence?.payment_type !== 'kindergarden_vat_invoice';

  const [weekDays, setWeekDays] = useState(
    summerplayToWeekDays(currentOccurrence),
  );
  useEffect(() => {
    if (currentOccurrence) {
      setWeekDays(summerplayToWeekDays(currentOccurrence));
    }
  }, [currentOccurrence]);

  const handleSend = (type) => {
    setLoading(true);

    let data = {
      id: currentOccurrence?.id || '',
      //   genericType: genericModelTypes.suggestedPlace,
      genericType: genericModelTypes.suggestedPlaceNew,
      genericInfo: {
        service: currentService,
        suggestedAddress: currentForm.address?.text,
        franchise: currentFranchise,
        level: currentRobot,
        age: currentAge,
      },
      fullName: currentForm.name.text,
      school_class: currentForm.schoolClass.text,
      parent_full_name: currentForm.parentFullName.text,
      email: currentForm.email.text,
      birthday: formatDate(currentForm.date.text),
      mobile: currentForm.phone.text,
      days: weekDays
        .filter((day) => day.checked)
        .map((day) => format(day.date, 'yyyy-MM-dd')),
      known_client: currentForm.knownClient.value,
      comment: currentForm.comment.text,
      tos: agreements[0].checked ? agreements[0].message : '',
      policy: agreements[1].checked ? agreements[1].message : '',
      marketing: agreements[2].checked ? agreements[2].message : '',
      payment_type:
        currentOccurrence.payment_type === 'kindergarden_vat_invoice'
          ? 'kindergarden_vat_invoice'
          : currentForm.paymentType.text.value,
      postal_code: currentForm.postalCode.text,
      street_address: currentForm.streetAddress.text,
      city: currentForm.city.text,
      promo_coupon: currentForm.promoCoupon.text,
    };

    sendPost(data, type, formPageTexts.errorInfo).then(({ success, status }) => {
      if (success) {
        dispatch(sentForm(type));
        navigate(`${env.PUBLIC_URL}/thanks`, {state : {status: status}});
      } else {
        setLoading(false);
      }
    });
  };

  const addressInputComp = (
    <>
      <FormLabel>{formPageTexts.offerText}</FormLabel>
      <FormField
        type={'address'}
        hint={'np. Szkoła nr 56'}
        value={currentForm.address.text}
        valid={currentForm.address.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'address', text: value, valid: valid }),
          )
        }
      />
    </>
  );

  const isFilled = () => {
    if (isWorkshopService && isParentPaymentForm) {
      return (
        currentForm.date.valid &&
        currentForm.name.valid &&
        currentForm.email.valid &&
        currentForm.phone.valid &&
        currentForm.parentFullName.valid &&
        currentForm.paymentType.valid &&
        currentForm.streetAddress.valid &&
        currentForm.postalCode.valid &&
        currentForm.city.valid &&
        currentForm.knownClient.valid &&
        // currentForm.promoCoupon.valid &&
        isChecked(agreements)
      );
    }

    if (isWorkshopService) {
      return (
        currentForm.date.valid &&
        currentForm.name.valid &&
        currentForm.email.valid &&
        currentForm.phone.valid &&
        currentForm.paymentType.valid &&
        // currentForm.knownClient.valid &&
        isChecked(agreements)
      );
    }
    // summerplay

    return (
      currentForm.date.valid &&
      currentForm.name.valid &&
      validateWeekDays(weekDays) &&
      currentForm.email.valid &&
      currentForm.phone.valid &&
      // currentForm.knownClient.valid &&
      isChecked(agreements)
    );
  };

  const addressFields = (
    <>
      <FormLabel required>Rodzic: Imię i nazwisko</FormLabel>
      <FormField
        type={'parentFullName'}
        hint={'Anna Kowalska'}
        value={currentForm.parentFullName.text}
        valid={currentForm.parentFullName.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({
              field: 'parentFullName',
              text: value,
              valid: valid,
            }),
          )
        }
      />

      <FormLabel required>Adres</FormLabel>
      <FormField
        type={'streetAddress'}
        hint={'Ulica i numer domu'}
        value={currentForm.streetAddress.text}
        valid={currentForm.streetAddress.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({
              field: 'streetAddress',
              text: value,
              valid: valid,
            }),
          )
        }
      />

      <FormLabel required>Kod pocztowy</FormLabel>
      <FormField
        type={'postalCode'}
        hint={'w formacie 00-000'}
        value={currentForm.postalCode.text}
        valid={currentForm.postalCode.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({
              field: 'postalCode',
              text: value,
              valid: valid,
            }),
          )
        }
      />

      <FormLabel required>Miasto</FormLabel>
      <FormField
        type={'city'}
        hint={''}
        value={currentForm.city.text}
        valid={currentForm.city.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'city', text: value, valid: valid }),
          )
        }
      />
    </>
  );

  const isChecked = (array) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i].is_required && array[i].checked === false) {
        return false;
      }
    }

    return true;
  };

  let sentButton;
  if (addressInput) {
    sentButton = (
      <Button
        disabled={!isFilled()}
        type={'primary'}
        text={sendText}
        onClick={() => handleSend('generic')}
      />
    );
  } else {
    sentButton = (
      <Button
        disabled={!isFilled()}
        type={'primary'}
        text={sendText}
        onClick={() =>
          handleSend(isWorkshopService ? 'workshop' : 'summerplay')
        }
      />
    );
  }

  // TODO ROBERT this is shitty and there definitely is a better way
  let availableRobotsInLocation = [];
  if (availableWorkshopsCurrentLocation) {
    const availableRobotsInLocationIds = availableWorkshopsCurrentLocation
      .map((item) => item.workshop_type_id)
      .filter((value, index, self) => self.indexOf(value) === index);

    let availableRobots = convertWorkshopLevelsToRobotAccordionWithSpecialPrice(
      currentFranchise.levels, availableWorkshopsCurrentLocation
    );

    availableRobotsInLocation = availableRobots.filter((obj) => {
      return availableRobotsInLocationIds.includes(obj.id);
    });
  }

  let samePlaceList = [];
  if (availableWorkshops && currentLocationId) {
    samePlaceList = availableWorkshops.filter(
      (ws) => ws.workshop_location_id === currentLocationId,
    );

    isWorkshopService
      ? sortByCyclicDate(samePlaceList)
      : sortByStartDate(samePlaceList);
  }

  const handleOccurrenceSelection = (item) => {
    dispatch(selectedOccurrence(item.ws));
    navigate(
      `${env.PUBLIC_URL}/${currentFranchise.id}/${currentService.value}/${
        (currentAge ? currentAge.value ?? 0 : 0) || 0
      }/${currentRobot.id}/${currentLocationId}/${
        item.ws.id || 0
      }/formularzMiasto`,
    );
  };

  const availableWorkshopsCurrentLocationAndLevel = (
    availableWorkshopsCurrentLocation ?? []
  ).filter((ws) => ws.workshop_type_id === currentRobot.id);

  const handleRobotSelection = (option) => {
    dispatch(selectedRobot(option));

    const randomWorkshopMatchingLevel =
      availableWorkshopsCurrentLocation.filter(
        (ws) => ws.workshop_type_id === option.id,
      )[0];

    dispatch(selectedOccurrence(randomWorkshopMatchingLevel));
    navigate(
      `${env.PUBLIC_URL}/${currentFranchise.id}/${currentService.value}/${
        (currentAge ? currentAge.value : 0) || 0
      }/${option.id}/${currentLocationId}/${
        randomWorkshopMatchingLevel.id || 0
      }/formularzMiasto`,
    );
    // fakeDelay(() => navigate(linkCheckSlash(location.pathname, option.value)));
  };

  const shouldDisplayPrice =
    (availableWorkshopsCurrentLocation ?? []).filter((ws) => {
      return ws.payment_type === 'kindergarden_vat_invoice';
    }).length === 0;

  const convDate = (isWorkshopService, currentOccurrence, info) => {
    const date = isWorkshopService
      ? currentOccurrence?.show_lesson_time
      : currentOccurrence?.start_date;

    if (date) {
      return format(
        new Date(date),
        isWorkshopService ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy',
      );
    } else {
      return info;
    }
  };

  const currentWSStartDate = convDate(true, currentOccurrence, 'Nieustalone');

  const content = (
    <>
      <FormLabel type={'big'}>{formPageSingleTexts.locationLabel}</FormLabel>

      <LocationInfo
        locationName={currentOccurrence?.location_title || ''}
        locationAddress={currentOccurrence?.physical_address || ''}
      />

      <FormLabel type={'big'}>Wybierz poziom zajęć</FormLabel>

      <SelectOption
        items={convertWorkshopLevelsToRobotAccordionWithSpecialPrice(availableRobotsInLocation, availableWorkshopsCurrentLocation)}
        selected={currentRobot}
        onClick={handleRobotSelection}
        displayPrimaryButton={false}
        shouldDisplayPrice={shouldDisplayPrice}
      />

      <FormLabel type={'big'}>{formPageSingleTexts.mainLabel}</FormLabel>
      <AccordionOption
        data={availableWorkshopsCurrentLocationAndLevel.map((ws, index) =>
          convWorkshopToOption(currentService.value, ws, mapPageTexts, index),
        )}
        selected={convWorkshopToOption(
          currentService.value,
          currentOccurrence,
          mapPageTexts,
          availableWorkshopsCurrentLocationAndLevel.findIndex(
            (item) => item.id === currentOccurrence?.id,
          ),
        )}
        onClick={handleOccurrenceSelection}
        placeholder={''}
      />

      <div>
        <div className="FormPageSingle-generaltile-wrapper">
          <GeneralTile
            key={0}
            width={'30%'}
            data={{
              type: 2,
              image: newIcons.school,
              title: 'Zapisanych: ' + currentOccurrence?.signups,
              description: 'Limit miejsc: ' + currentOccurrence?.places_total,
            }}
          />
          <GeneralTile
            key={0}
            width={'30%'}
            data={{
              type: 2,
              image: newIcons.robot,
              title: currentWSStartDate,
              description: 'Pierwsze zajęcia',
            }}
          />
        </div>
      </div>

      <FormLabel type={'big'}>{formPageTexts.mainLabel}</FormLabel>
      <FormLabel addStyle={{ margin: 0 }}>{formPageTexts.whyData}</FormLabel>
      {addressInput ? addressInputComp : null}

      <FormLabel required>{formPageTexts.nameLabel}</FormLabel>
      <FormField
        type={'name'}
        hint={formPageTexts.nameHint}
        value={currentForm.name.text}
        valid={currentForm.name.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'name', text: value, valid: valid }),
          )
        }
      />
      <FormLabel required>{formPageTexts.datapickerLabel}</FormLabel>
      <DatePickerFormField
        value={currentForm.date.text ? currentForm.date.text : ''}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'date', text: value, valid: valid }),
          )
        }
        valid={currentForm.date.valid}
        age={currentAge?.value}
      />

      {!isWorkshopService && !currentOccurrence?.only_all_week && (
        <>
          <FormLabel>{formPageTexts.weekDaysLabel}</FormLabel>
          <WeekDayPicker
            data={weekDays}
            changeFnc={setWeekDays}
            isValid={validateWeekDays(weekDays)}
          />
        </>
      )}

      <FormLabel required>{formPageTexts.emailLabel}</FormLabel>
      <FormField
        type={'email'}
        hint={formPageTexts.emailHint}
        value={currentForm.email.text}
        valid={currentForm.email.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'email', text: value, valid: valid }),
          )
        }
      />
      <FormLabel required>{formPageTexts.phoneLabel}</FormLabel>
      <FormField
        type={'phone'}
        hint={formPageTexts.phoneHint}
        value={currentForm.phone.text}
        valid={currentForm.phone.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'phone', text: value, valid: valid }),
          )
        }
      />

      {isWorkshopService && !addressInput && (
        <>
          <FormLabel required>
            Forma płatności (w przypadku podpisania umowy)
          </FormLabel>

          <AccordionOptionPayment
            type={'paymentType'}
            data={availablePaymentOptions}
            selected={currentForm.paymentType.text}
            valid={currentForm.paymentType.valid}
            onClick={(value) => {
              dispatch(
                changedContactForm({
                  field: 'paymentType',
                  text: value,
                  valid: validate(value.value, 'paymentType') === 'success',
                }),
              );
            }}
            placeholder={''}
          />
        </>
      )}

      {isParentPaymentForm && isWorkshopService && !addressInput
        ? addressFields
        : ''}

      {isWorkshopService && (
        <>
          <FormLabel>{formPageTexts.schoolClassLabel}</FormLabel>
          <FormField
            value={currentForm.schoolClass.text}
            valid={currentForm.schoolClass.valid}
            onChange={(value, valid) =>
              dispatch(
                changedContactForm({
                  field: 'schoolClass',
                  text: value,
                  valid: valid,
                }),
              )
            }
          />
        </>
      )}

      <FormLabel required>{formPageTexts.knownClientLabel}</FormLabel>
      <AccordionFormField
        formType
        data={[
          { text: 'Tak', value: true },
          { text: 'Nie', value: false },
        ]}
        selected={currentForm.knownClient}
        onClick={(item) =>
          dispatch(
            changedKnownClient({
              field: 'knownClient',
              text: item.text,
              value: item.value,
              valid: true,
            }),
          )
        }
        placeholder={formPageTexts.knownClientHint}
      />

      {currentForm.knownClient.value && (
        <>
          <FormLabel>Kupon promocyjny (jeżeli posiadasz)</FormLabel>
          <FormField
            hint={''}
            value={currentForm.promoCoupon.text}
            valid={currentForm.promoCoupon.valid}
            onChange={(value, valid) =>
              dispatch(
                changedContactForm({
                  field: 'promoCoupon',
                  text: value,
                  valid: valid,
                }),
              )
            }
          />
        </>
      )}

      <FormLabel>{formPageTexts.commentLabel}</FormLabel>
      <FormField
        value={currentForm.comment.text}
        valid={currentForm.comment.valid}
        onChange={(value, valid) =>
          dispatch(
            changedContactForm({ field: 'comment', text: value, valid: valid }),
          )
        }
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <FormPageAgreement agreements={agreements} />
      </div>
      <div className={styles.navWrapper}>{sentButton}</div>
    </>
  );

  return (
    <SingleInputPage
      page={currentPage}
      currentStep={currentPage.step}
      content={content}
      noTiles
      backButton={false}
      nextButton={false}
      loading={loading}
    />
  );
}

export default FormPageSingle;
